import React, { useState, useEffect, useContext, useRef,useCallback } from "react";
import "./applePayButton.scss";
import { useHistory } from "react-router-dom";
import { ApplePayButton } from "react-apple-pay-button";
import { withTranslation, useTranslation, Trans } from "react-i18next";
import StateContext from "../../StateContext";
import DispatchContext from "../../DispatchContext";


function ApplePayBtn({handleClickApplePay}) {
  const appState = useContext(StateContext);
  const { t } = useTranslation();
  const appDispatch = useContext(DispatchContext);
  const onRequestApplePay = useCallback(() => /* TODO */ []);







  return (
    <>
      <ApplePayButton id="applePayButtonl1" 
      onClick={handleClickApplePay}
       >
      {/* {t("pay.pay-with-apple")}  */}
      {/* hello  */}
    </ApplePayButton>

    </>


  );
}



export default withTranslation()(ApplePayBtn);

